// const getCleanedCssFromStyleSheets = (): string => {
//     let cleanedCss = "";

//     const appendRule = (rule: CSSRule): void => {
//         // CSSStyleRule, CSSFontFaceRule, CSSPageRule, etc. — anything with a single cssText
//         if ("style" in rule || rule.type === CSSRule.FONT_FACE_RULE ||
//             rule.type === CSSRule.PAGE_RULE || rule.type === CSSRule.KEYFRAMES_RULE) {
//             cleanedCss += rule.cssText + "\n";
//             return;
//         }
//         // CSSMediaRule / CSSSupportsRule / CSSLayerBlockRule — flatten and re-walk
//         if (rule instanceof CSSMediaRule || (rule as CSSGroupingRule).cssRules) {
//             const group = rule as CSSGroupingRule;
//             for (const child of Array.from(group.cssRules)) {
//                 appendRule(child);
//             }
//             return;
//         }
//         // Fallback — keep unknown rule types
//         cleanedCss += rule.cssText + "\n";
//     };

//     for (const sheet of Array.from(document.styleSheets)) {
//         try {
//             if (!sheet.cssRules) continue;
//             for (const rule of Array.from(sheet.cssRules)) {
//                 appendRule(rule);
//             }
//         } catch (e) {
//             console.warn("Skipped cross-origin stylesheet evaluation:", e);
//         }
//     }

//     // Reset any print-specific hiding that may have leaked through
//     cleanedCss +=
//         "html { background: #fff !important; }\n" +
//         "body { padding: 0!important; height: auto!important; background: #fff !important; }\n";
//     return cleanedCss;
// };

const getCleanedCssFromStyleSheets2 = (element: HTMLElement): string => {
    let cleanedCss = "";

    // --- PURGING LOGIC ---
    // Check if the selector (e.g. ".MuiButton-root" or ".css-1xx34") exists inside our print element.
    // Keep the rule if: the element contains a match, it's a pseudo-element, or a global selector (html, body, *).
    const shouldKeepStyleRule = (selectorText: string): boolean => {
        try {
            const hasMatch = element.querySelector(selectorText) !== null;
            return hasMatch || selectorText.startsWith("@") || ["html", "body", "*"].includes(selectorText);
        } catch {
            // If querySelector fails on complex selectors (like :hover), keep the rule safely.
            return true;
        }
    };

    const appendRule = (rule: CSSRule): void => {
        // CSSStyleRule with a selector — run through purge check
        if (rule instanceof CSSStyleRule) {
            if (shouldKeepStyleRule(rule.selectorText)) {
                cleanedCss += rule.cssText + "\n";
            }
            return;
        }
        // CSSFontFaceRule, CSSPageRule, CSSKeyframesRule — keep without purge
        if ("style" in rule || rule.type === CSSRule.FONT_FACE_RULE ||
            rule.type === CSSRule.PAGE_RULE || rule.type === CSSRule.KEYFRAMES_RULE) {
            cleanedCss += rule.cssText + "\n";
            return;
        }
        // CSSMediaRule / CSSSupportsRule / CSSLayerBlockRule — flatten and re-walk
        if (rule instanceof CSSMediaRule || (rule as CSSGroupingRule).cssRules) {
            const group = rule as CSSGroupingRule;
            for (const child of Array.from(group.cssRules)) {
                appendRule(child);
            }
            return;
        }
        // Fallback — keep unknown rule types (CSSImportRule, CSSCommentRule, CSSNamespaceRule, etc.)
        cleanedCss += rule.cssText + "\n";
    };

    for (const sheet of Array.from(document.styleSheets)) {
        try {
            if (!sheet.cssRules) continue;
            for (const rule of Array.from(sheet.cssRules)) {
                appendRule(rule);
            }
        } catch (e) {
            console.warn("Skipped cross-origin stylesheet evaluation:", e);
        }
    }
    return cleanedCss +
        "html { background: #fff !important; }\n" +
        "body { padding: 0!important; height: auto!important; background: #fff !important; }\n";
};

// export const getPrintHtml = (sourceElementId: string, title: string): string => {
//     const element = document.getElementById(sourceElementId);
//     if (!element) return "";
//     const cleanedCss = getCleanedCssFromStyleSheets2(element);
//     const htmlContent = element.innerHTML;

//     return `
//         <!DOCTYPE html>
//         <html lang="en">
//         <head>
//         <meta charset="UTF-8">
//         <title>${title}</title>
//         <style>
//             body { font-family: Roboto, Helvetica, Arial, sans-serif; margin: 0; padding: 0; }
//             * { box-shadow: none !important; text-shadow: none !important; }
//             ${cleanedCss}
//         </style>
//         </head>
//         <body>
//         <div id="pdf-root">
//             ${htmlContent}
//         </div>
//         </body>
//         </html>
//     `;
// };

export const getPrintBodyHtml = (sourceElementId: string): string => {
    const element = document.getElementById(sourceElementId);
    if (!element) return "";
    const cleanedCss = getCleanedCssFromStyleSheets2(element);
    const htmlContent = (element.cloneNode(true) as HTMLElement).innerHTML;

    return `<div style="margin: 0!important; padding: 0!important; background-color: #ffffff!important;">
        <style>
            ${cleanedCss}
        </style>
        ${htmlContent}
    </div>`;
};